<template>
  <div class="batchBox">
    <div class="backBox">
      <span class="goback" @click="goToTable">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-fanhui"></use>
        </svg>
        返回</span>
    </div>
    <div style="margin-top: 20px;">
      <span class="formContent">
        <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="120px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="订单编号">
              <span style="width: 200px">{{rowInfo.orderNum}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="下单时间">
              <span style="width: 200px">{{rowInfo.carRentalTime}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="起始时间">
              <span style="width: 200px">{{rowInfo.departureTime}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="起始地点">
              <span style="width: 200px">{{rowInfo.startPointName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="起始里程">
              <span style="width: 200px">{{rowInfo.startMileage}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束时间">
              <span style="width: 200px">{{rowInfo.endTime}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="结束地点">
              <span style="width: 200px">{{rowInfo.endPointName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束里程">
              <span style="width: 200px">{{rowInfo.endMileage}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单状态">
              <span style="width: 200px">{{rowInfo.orderStatusTxt}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="企业名称">
              <span style="width: 200px">{{rowInfo.cusName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目名称">
              <span style="width: 200px">{{rowInfo.deptName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="城市">
              <span style="width: 200px">{{rowInfo.cityName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="管理员">
              <span style="width: 200px">{{rowInfo.cusAdminName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用车人">
              <span style="width: 200px">{{rowInfo.empName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <span style="width: 200px">{{rowInfo.empPhone}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="所属车队">
              <span style="width: 200px">{{rowInfo.driverCompany}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="司机">
              <span style="width: 200px">{{rowInfo.orderDriverName}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <span style="width: 200px">{{rowInfo.orderDriverPhone}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="车辆类型">
              <span style="width: 200px">{{rowInfo.vehicleBrand}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌号">
              <span style="width: 200px">{{rowInfo.plateNumber}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用车类型">
              <span style="width: 200px">{{rowInfo.carRentalLong=='4'?'半日租':'日租'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="8">
            <el-form-item label="租车类型">
               <span style="width: 200px">{{rowInfo.orderTypeTxt}}</span>
            </el-form-item>
          </el-col>
           <el-col :span="8">
            <el-form-item label="租车数量">
               <span style="width: 200px">{{rowInfo.carNumber}}辆</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
           <el-form-item label="用车时间">
              <span style="width: 200px">{{rowInfo.carTime}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="乘车人数">
              <span style="width: 200px">{{rowInfo.personNumber}}人</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用时时长">
               <span style="width: 200px">{{rowInfo.useCarTime}}</span>
            </el-form-item>
          </el-col>
         <el-col :span="8">
            <el-form-item label="备注">
              <span style="width: 200px">{{rowInfo.remark}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="起始里程照片">
                <div class="imgbox" v-if="rowInfo.startMileageAttachUrls" >
                  <template v-for="itemurl in rowInfo.startMileageAttachUrls">
                       <img :src="itemurl" @click="onPreview(itemurl)" v-bind:key="itemurl"/>
                  </template>
                </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
             <el-form-item label="终止里程照片">
               <div class="imgbox" v-if="rowInfo.endMileageAttachUrls">
                  <template v-for="itemurl in rowInfo.endMileageAttachUrls">
                       <img :src="itemurl" @click="onPreview(itemurl)" v-bind:key="itemurl"/>
                  </template>
               </div>
            </el-form-item>
          </el-col>
         <el-col :span="8">
             <el-form-item label="住宿费">
              <span style="width: 200px">{{rowInfo.putUpFee}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="停车费">
              <span style="width: 200px">{{rowInfo.parkingFee}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
             <el-form-item label="高速费">
              <span style="width: 200px">{{rowInfo.highSpeedFee}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="乘车确认人">
              <span style="width: 200px">{{rowInfo.rideConfirmerName}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
             <el-form-item label="乘车确认时间 ">
              <span style="width: 200px">{{rowInfo.rideConfirmTime}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="乘车人">
              <template v-if="rowInfo.passengerList!=null">
               <span style="margin-right:5px;" v-for="passengers in rowInfo.passengerList"  v-bind:key="passengers.id">{{passengers.perName}}</span>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
           <el-form-item label="途经地点">
              <template v-if="rowInfo.passingPlaceList!=null">
               <p style="" v-for="place in rowInfo.passingPlaceList" v-bind:key="place.id">● {{place.pointName}}</p>
              </template>
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="8">
            <el-form-item label="订单确认时间">
               <span style="width: 200px">{{rowInfo.confirmTime}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单确认类型">
               <span style="width: 200px">{{rowInfo.confirmTypeTxt}}</span>
            </el-form-item>
          </el-col>
            <el-col :span="8">
            <el-form-item label="实际收车位置">
               <span style="width: 200px">{{rowInfo.confirmAddress}}</span>
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
            <el-form-item label="收车位置提示">
               <span style="width: 200px">{{rowInfo.confirmDistanceTips}}</span>
            </el-form-item>
          </el-col>
         <el-col :span="8">
            <el-form-item label="车辆费用合计">
               <span style="width: 200px">{{rowInfo.carAmountTotal}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="超时费">
               <span style="width: 200px">{{rowInfo.timeoutAmountTotal}}</span>
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="8">
            <el-form-item label="油费合计">
               <span style="width: 200px">{{rowInfo.oilAmountTotal}}</span>
            </el-form-item>
          </el-col>
         <el-col :span="8">
            <el-form-item label="合计总费用">
               <span style="width: 200px">{{rowInfo.amountTotal}}</span>
            </el-form-item>
          </el-col>
         <el-col :span="8">
            <el-form-item label="税费">
               <span style="width: 200px">{{rowInfo.taxCosts}}</span>
            </el-form-item>
          </el-col>
         <el-col :span="8">
            <el-form-item label="服务费">
               <span style="width: 200px">{{rowInfo.serviceCosts}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="应收款合计">
               <span style="width: 200px">{{rowInfo.allAmountTotal}}</span>
            </el-form-item>
          </el-col>
         <el-col :span="8">
            <el-form-item label="超时时间">
              <span style="width: 200px">{{rowInfo.timeOut}}</span>
            </el-form-item>
         </el-col>
      </el-row>
      </el-form>
    </span>
    <span slot="footer" class="footer">
        <el-button type="primary" v-if="rowInfo.approvalStatus=='10020001'" size="mini" @click="agree">同意</el-button>
        <el-button type="danger" v-if="rowInfo.approvalStatus=='10020001'" size="mini" @click="turnDown">驳回</el-button>
        <el-button type="primary" size="mini" @click="handleMap">行车路线</el-button>
        <el-button size="mini"  @click="goToTable">返回</el-button>
    </span>
    </div>
    <div>
      <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="srcList" />
    </div>
    <!--弹出内容-->
    <turn-down v-if="showVisible" ref="turnDown" @refresh="goToTable"/>
    <driving-map v-if="showMapVisible" ref="map" />

  </div>
</template>
<script>
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
  import { adminAudit, getDynamicFormValue } from  "@/api/order/orderinfo"
  import turnDown from './turndown'
  import drivingMap from './drivingMap'
  export default {
    components: { ElImageViewer,turnDown,drivingMap },
    data() {
      return {
        showVisible: false,
        showMapVisible:false,
        showViewer: false, // 显示查看器
        activeIndex: 0,
        id: '',
        userType: '',
        title: '详情',
        rowInfo: {
        },
        srcList:[],
        oldSrcList:[] //记录原始顺序
      }
    },
    mounted() {
      // 加载参数
      this.id = this.$route.query.id
      this.userType = this.$route.query.userType
      this.initData(this.id);
    },
    methods: {
      initData(id) {
        if (id) {
          getDynamicFormValue(id).then((res) => {
            if(res.data.code==0){
              let data = res.data
              this.rowInfo = data.data
              if(this.rowInfo.startMileageAttachUrl){
                  let startMileageAttachUrl = [];
                  let startMileageAttachUrls = this.rowInfo.startMileageAttachUrl.split(",");
                  startMileageAttachUrls.forEach(item=>{
                      startMileageAttachUrl.push(process.env.VUE_APP_BASE_API +''+ item);
                      this.srcList.push(process.env.VUE_APP_BASE_API +''+ item);
                  });
                  this.$set(this.rowInfo,'startMileageAttachUrls', startMileageAttachUrl)
              }
              if(this.rowInfo.endMileageAttachUrl){
                  let endMileageAttachUrl = [];
                  let endMileageAttachUrls = this.rowInfo.endMileageAttachUrl.split(",");
                  endMileageAttachUrls.forEach(item=>{
                      endMileageAttachUrl.push(process.env.VUE_APP_BASE_API +''+ item);
                      this.srcList.push(process.env.VUE_APP_BASE_API +''+ item);
                  });
                  this.$set(this.rowInfo,'endMileageAttachUrls', endMileageAttachUrl)
              }
              this.oldSrcList = this.srcList;
            }
          })
        }
      },
      //通过
      agree(){
        let obj = {};
        obj.id = this.rowInfo.id;
        obj.approvalStatus = '10020002';
        this.$confirm("确定同意该订单的申请吗？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          adminAudit(obj).then((res) => {
            this.$message.success("审核成功")
            this.goToTable()
          })
        })
      },
      //驳回
      turnDown(){
        this.showVisible = true
        this.$nextTick(() => {
          this.$refs.turnDown.init(this.rowInfo.id)
        })
      },
      // 显示路线
      handleMap() {
        this.showMapVisible = true
        this.$nextTick(() => {
          this.$refs.map.init(this.rowInfo)
        })
      },
      onPreview(url) {
        this.showViewer = true
        let tempImgList = [];//所有图片地址
        this.oldSrcList.map(item=>{
          tempImgList.push(item);
        });
        let temp = [];
        for (let i = 0; i < tempImgList.length; i++) {
          if(tempImgList[i]==url){
            temp = tempImgList.splice(0,i);
          }
        }
        this.srcList = tempImgList.concat(temp);//将当前图片调整成点击缩略图的那张图片
      },
      // 关闭查看器
      closeViewer() {
        this.showViewer = false
      },
      goToTable() {
        // 返回数据页面
        //this.$router.go(-1);
        this.$router.back();
        /*if(this.userType=='2'){

        }*/
        /*this.$router.push({
          path: '/order/manage',
        })*/
      }
    }
  }
</script>
<style scoped  rel="stylesheet/scss">
  .backBox{
    /*margin-bottom: 20px;*/
  }
  .goback{
    width: 70px;
    padding:8px;
    border:1px solid #cccccc;
    color:#cccccc;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    line-height: 16px;
    font-size: 14px;
    cursor: pointer;
  }
  .goback:hover{
    border:1px solid #269cff;
    color:#269cff;
  }
  .batchBoxTitle{
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }
  .imgbox{
    width: 300px;
  }
  .imgbox img{
    width: 100px;
    max-height: 100px;
    margin-right: 10px;
  }
  .footer{
    position: fixed;
    bottom: 10px;
    left: 50%;
  }
</style>
